import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { api } from "@/lib/util";
import { ReviewCard } from "./Widgets";

const HIDE = ["/", "/avis", "/panier", "/confirmation", "/mon-compte", "/connexion", "/commande"];
let cache = null;

export const ReviewsTrack = ({ items }) => items.length <= 5
  ? <div className="container-x"><div className="rv-static" data-testid="reviews-static">{items.map((r) => <div key={r.id} className="rv-item"><ReviewCard r={r} /></div>)}</div></div>
  : <div className="rv-marquee"><div className="rv-track">{[...items, ...items].map((r, i) => <div key={r.id + i} className="rv-item" aria-hidden={i >= items.length}><ReviewCard r={r} /></div>)}</div></div>;

export const SiteReviews = () => {
  const { pathname } = useLocation();
  const [items, setItems] = useState(cache || []);
  useEffect(() => { if (!cache) api.get("/reviews/shop", { params: { limit: 20 } }).then((r) => { cache = r.data.items; setItems(cache); }).catch(() => {}); }, []);
  if (!items.length || HIDE.some((h) => (h === "/" ? pathname === "/" : pathname === h || pathname.startsWith(h + "/")))) return null;
  return (
    <section className="reviews-band" data-testid="site-reviews-marquee" aria-label="Avis clients">
      <div className="container-x pt-14 sm:pt-20"><p className="eyebrow mb-2">Avis</p><div className="flex flex-wrap items-end justify-between gap-3 mb-10"><h2 className="text-4xl sm:text-5xl font-light">Avis clients</h2><Link to="/avis" className="text-sm underline underline-offset-4 hover:text-black/70" data-testid="site-reviews-link">Voir tous les avis · Donner mon avis</Link></div></div>
      <ReviewsTrack items={items} />
    </section>
  );
};
